module.exports = __webpack_public_path__ + "assets/img/aa4c6e703a18c98d9aa25fe567f2c878.svg";